<h2 mat-dialog-title>
  {{ data.title | translate: { param1: data.paramTitle?.param1 ?? '', param2: data.paramTitle?.param2 ?? '', param3:
  data.paramTitle?.param3 ?? '' } }}
</h2>

<div mat-dialog-content>

  <p>
    {{ data.message | translate:{ param1: data.paramMessage?.param1 ?? '', param2: data.paramMessage?.param2 ?? '',
  param3: data.paramMessage?.param3 ?? '' } }}
  </p>

  <mat-radio-group [(ngModel)]="selected">

    <mat-radio-button
      *ngFor="let option of data.options"
      [value]="option.value">

      {{ option.label | translate }}

      <div class="hint" *ngIf="option.hint">
        {{ option.hint | translate }}
      </div>

    </mat-radio-button>

  </mat-radio-group>

</div>

<div mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="null">
    {{ data.cancelText | translate }}
  </button>

  <button mat-raised-button color="primary" [mat-dialog-close]="selected">
    {{ data.confirmText | translate }}
  </button>
</div>
